module.exports = __webpack_public_path__ + "img/cloud_saving.d6c703b5.svg";